<template>
  <div>
    <!-- 土地流转数据表格 -->
    <el-table :data="landTransferData" style="width: 100%">
      <el-table-column prop="transferNo" label="流转合同编号" width="180" align="center">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            class="transfer-number-link"
            @click="handleTransferNoClick(scope.row)"
          >
            {{ scope.row.transferNo }}
          </a>
        </template>
      </el-table-column>
      、
      <el-table-column
        prop="transferArea"
        label="流转面积(亩)"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="landType"
        label="土地类型"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="transferPeriod"
        label="流转期限"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column prop="location" label="所在地" width="300" align="center"></el-table-column>
      <el-table-column prop="totalAmount" label="流转合同总金额（元）" align="center"></el-table-column>
    </el-table>

    <!-- 土地流转详情弹窗 -->
    <LandTransferDetailDialog
      :visible.sync="landTransferDetailDialogVisible"
      :transferNo="selectedTransferNo"
      :xmbsm="selectedXmbsm"
    />
  </div>
</template>

<script>
import LandTransferDetailDialog from './LandTransferDetailDialog.vue'

export default {
  name: 'LandTransferDataTab',
  components: {
    LandTransferDetailDialog
  },
  props: {
    landTransferInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      landTransferDetailDialogVisible: false,
      selectedTransferNo: '',
      selectedXmbsm: '',

      // 土地流转数据表格数据
      _landTransferData: [
        {
          xmbsm: '1234567890',
          transferNo: 'ZR20230601001',
          transferArea: 120.5,
          landType: '耕地',
          transferPeriod: '2023-06-01 至 2028-05-31',
          location: '江苏省南京市',
          totalAmount: '￥360,000.00'
        },
        {
          xmbsm: '1234567890',
          transferNo: 'ZR20230601002',
          transferArea: 85.3,
          landType: '林地',
          transferPeriod: '2023-06-01 至 2030-05-31',
          location: '江苏省苏州市',
          totalAmount: '￥280,000.00'
        },
        {
          xmbsm: '1234567890',
          transferNo: 'ZR20230601003',
          transferArea: 200.0,
          landType: '耕地',
          transferPeriod: '2023-06-01 至 2026-05-31',
          location: '江苏省无锡市',
          totalAmount: '￥600,000.00'
        }
      ]
    }
  },
  computed: {
    landTransferData() {
      return this.mapToLandTransferData(this.landTransferInfoList)
    }
  },
  methods: {
    // 处理流转编号点击
    handleTransferNoClick(row) {
      console.log('点击了流转编号:', row.transferNo)
      this.selectedTransferNo = row.transferNo
      this.selectedXmbsm = row.xmbsm || ''
      this.landTransferDetailDialogVisible = true
    },

    mapToLandTransferData(data) {
      return data.map(item => ({
        xmbsm: item.xmbsm || '',
        transferNo: item.code || '',
        transferArea: item.area || '',
        landType: item.landType || '',
        transferPeriod: item.transferTerm || '',
        location: item.address || '',
        totalAmount: item.amount || ''
      }))
    }
  }
}
</script>

<style lang="less" scoped>
// 流转编号链接样式
.transfer-number-link {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}
</style>
